export default {
  uiTheme: "dhl",
  smallViewportBreak: 768,
  mediumViewportBreak: 1024,
};
